import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { styled } from "@mui/material/styles";
import { Typography, TypographyProps, Link } from "@mui/material";

import { capitalizeFirstChar } from "../../utils/textUtils";
import { useAccountBalances } from "../../context/balanceContext";

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(3),
}));

const StyledDialogContentText = styled(DialogContentText)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  fontSize: "1rem",
  lineHeight: 1.6,
}));

const HighlightText = styled(Typography)<TypographyProps>(({ theme }) => ({
  fontWeight: "bold",
  color: theme.palette.primary.main,
  display: "inline",
}));

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

type TSendTxAlert = {
  open: boolean;
  link: string;
  handleClose: () => void;
};

export default function BalanceDialog({ open, handleClose, link }: TSendTxAlert) {
  const confirmButtonRef = React.useRef(null);
  const { balance, allowances, totalOST: totalBalance } = useAccountBalances();

  const handleKeyPressed = async (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      confirmButtonRef.current.click();
    } else if (e.key === "Escape") {
      handleClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      onKeyDown={handleKeyPressed}
      keepMounted
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      TransitionComponent={Transition}
    >
      <DialogTitle id="alert-dialog-title">
        {capitalizeFirstChar(`Your total balance: ${totalBalance.getPrettyValue()}`)} OST
      </DialogTitle>

      <StyledDialogContent>
        <StyledDialogContentText id="alert-dialog-description">
          balance (can be transferred):{" "}
          <HighlightText component="span">{balance.getPrettyValue()} OST</HighlightText>
        </StyledDialogContentText>

        <StyledDialogContentText id="alert-dialog-description">
          allowance (cannot be transferred):{" "}
          <HighlightText component="span">{allowances.getPrettyValue()} OST</HighlightText>
        </StyledDialogContentText>
      </StyledDialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
        <Button
          ref={confirmButtonRef}
          onClick={() => {
            console.log("clicked!");
          }}
        >
          <Link
            href={link}
            rel="noopener noreferrer"
            sx={{
              textDecoration: "none",
            }}
          >
            Get More
          </Link>
        </Button>
      </DialogActions>
    </Dialog>
  );
}
